import React from 'react';
import Modal from './Modal';
import Btn from './Btn';
import { COLORS } from '../../theme';

export default function ConfirmModal({ titulo, mensagem, textoConfirmar = 'Confirmar', textoCancelar = 'Cancelar', variante = 'primary', processando, onConfirmar, onCancelar }) {
  return (
    <Modal
      titulo={titulo}
      onFechar={onCancelar}
      largura={440}
      rodape={
        <>
          <Btn variante="ghost" onClick={onCancelar} disabled={processando}>{textoCancelar}</Btn>
          <Btn variante={variante} onClick={onConfirmar} disabled={processando}>{processando ? 'Processando...' : textoConfirmar}</Btn>
        </>
      }
    >
      <p style={{ fontSize: 14, color: COLORS.text, margin: 0, lineHeight: 1.6 }}>{mensagem}</p>
    </Modal>
  );
}
